// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/cars-contrate/list',
    name: 'cars-contrate-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/contratos/cars/ContrateCars.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'contrato_cars',
    },
  },
  {
    path: '/cars-contrate/update',
    name: 'cars-contrate-update',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/contratos/cars/form/ContrateCars.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'contrato_cars',
    },
  },

  {
    path: '/cars-contrate/export',
    name: 'cars-contrate-export',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/contratos/cars/exportations/List.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'contrato_cars',
    },
  },
]

export default formTable
